export default __webpack_public_path__ + "static/media/slide4.934a0fc4.jpg";